<template>
  <div class="report_item_wrapper" ref="alerts">
    <div class="report_header">
      <div class="item_title">
        <i class="iconfont">&#xe655;</i>
        <span>{{$t('title.huxipinlv')}}</span>
        <span class="srart_end_time" v-show="echartShows">{{time}}</span>
      </div>
      <div class="item_warn" v-show="echartShows">
        <!-- 
          -+-+
        -->
      </div>
    </div>
    <div class="echarts_wrapper" v-show="echartShows">
      <!-- 图表数据 -->
      <div class="draw_echarts">
        <keep-alive>
          <div class="chart" ref="chart" :id="id"></div>
        </keep-alive>
      </div>
      <p class="chartTip">*{{$t('tag.shipin')}}</p>
      <div class="parameter">
        <div class="cal">
          <div
            :class="['value',wholeDayAve.value !=='' &&wholeDayAve.color!=='normal'?wholeDayAve.color:'normal']"
          >
            <template v-if="wholeDayAve!==''">
              <strong>{{wholeDayAve.value}}</strong>
              <i>{{$t('tag.xinlv.danwei')}}</i>
            </template>
            <template v-else>--</template>
          </div>
          <p class="title">{{$t('tag.breathe.quantianpingjun')}}</p>
        </div>
      </div>

      <!-- 健康报告 -->
      <div class="read part-top">
        <div class="header">
          <i class="iconfont">&#xe61d;</i>
          <h2>{{$t('title.secondaryTitle.breatheReport')}}</h2>
        </div>
        <div class="content">
          <div :class="['article',contentShow ? 'show' : 'hidden']">
            <!--  v-for="(item,index) in content" :key="index" -->
            <p>{{content}}</p>
          </div>
          <div :class="['mask',contentShow ? 'show' : 'hidden']" @click="contentToggle">
            <i class="iconfont" v-show="!contentShow">&#xe632;</i>
            <i class="iconfont" v-show="contentShow">&#xe633;</i>
          </div>
        </div>
      </div>
    </div>
    <!-- 暂无数据 -->
    <div class="nodata" v-if="!echartShows">{{$t('tag.breathe.noweek')}}</div>
    <!-- 弹窗 -->
  </div>
</template>
<script>
export default {
  name: "weekBreathe",
  props: {
    sendTime: {
      type: String,
      require: true,
      default: ""
    }
  },
  data() {
    return {
      emit: {},
      echartShows: true,
      id: "weekBreathe",
      contentShow: false,
      // 图表
      threeseries: [],
      names: this.$t("components.weekRateName"),
      chart_x_time: [],
      wholeDayAve: "",
      content: "",
      time: "",
      statec: "",
      appType: {
        appName: this.$route.params.appName
      }
    };
  },
  mounted() {
    var echartsDom = document.getElementById(this.id);
    var contentHeight = window.getComputedStyle(echartsDom).height;
    var contentWidth = window.getComputedStyle(echartsDom).width;
    echartsDom.style.height = contentHeight;
    echartsDom.style.width = contentWidth;
  },
  methods: {
    getEchartsDataInfo() {
      // var _this = this
      if (this.sendTime === "") {
        return false;
      } else {
        let postData = {
          week: this.sendTime,
          userid: this.$route.params.userID,
          friendid: this.$route.params.friendID,
          token: this.$route.params.token
        };
        this.$axios
          .breathWeek(this.appType, postData)
          .then(this.getEchartsDataInfoSucc);
      }
    },

    getEchartsDataInfoSucc(res) {
      this.emit.code = res.code;
      this.$emit("breathcode", this.emit);
      if (res.code === 0 && res.data) {
        this.echartShows = true;
        const getData = res.data;
        this.wholeDayAve = getData.outlineData.aveHeartRate;

        this.statec = getData.outlineData.statec;
        this.content = this.$t("breathe.current");
        // this.$t("heartrate.week.a1") +
        // this.wholeDayAve.value +
        // this.$t("heartrate.week." + this.statec) +
        // this.warnings +
        // this.$t("tag.xinlv.ci");

        let startTime = getData.outlineData.startTime;
        let endTime = getData.outlineData.endTime;
        this.time = "(" + startTime + "-" + endTime + ")";
        // 图表数据
        this.chart_x_time = [];
        this.chart_x_time = getData.outlineData.time;
        this.threeseries = [];
        for (let j in getData.echarts) {
          this.threeseries.push(getData.echarts[j].avebreath);
        }
        this.init();
        this.setOption(this.options);
      } else {
        this.echartShows = false;
      }
    },
    init() {
      let _this = this;
      this.chart = this.$echarts.init(document.getElementById(this.id));
      // console.log('初始化：' + this.chart)
      window.addEventListener("resize", function() {
        _this.chart && _this.chart.resize();
      });
    },
    setOption(option) {
      if (!this.chart) {
        return;
      }
      this.chart.setOption(option);
    },
    contentToggle() {
      this.contentShow = !this.contentShow;
    },
    showTip() {
      this.$alertPl.show({
        // el: this.$refs.alerts,
        title: this.$t("tag.xiaotieshi.xinlv.title"),
        confirmMsg: this.$t("tag.guanbi"),
        text: this.$t("tag.xiaotieshi.xinlv.text")
      });
    },
    dispose() {
      if (!this.chart) {
        return;
      }
      this.chart.dispose();
      this.chart = null;
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  computed: {
    options() {
      return {
        series: {
          type: "bar",
          data: this.threeseries
        },
        color: ["#0082d6", "#29cc71", "#a747de"],
        grid: {
          containLabel: true,
          top: 30,
          bottom: 10,
          left: 0,
          right: 0
        },
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100
          }
        ],
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: this.names
        },
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#54657e",
              width: 1
            }
          },
          data: this.chart_x_time
        },
        yAxis: {
          type: "value",
          min: 0,
          interval: 5,
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#cad3df",
              width: 1
            }
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#54657e"
            }
          },
          axisTick: {
            show: false
          },
          data: this.weekBreatheValue
        }
      };
    }
  },
  components: {},
  watch: {
    sendTime: function(newval, oldval) {
      this.getEchartsDataInfo();
    }
  }
};
</script>
<style lang="stylus" scoped>
@import '~styles/variable.styl';
@import '~styles/global.styl';
</style>



// WEBPACK FOOTER //
// src/pages/week-data/components/weekBreathe.vue